export default __webpack_public_path__ + "static/media/new-version.e0429ae5.svg";